/* ============================================================
   FRAISE NOIRE — Bannière de consentement (CNIL)
   S'affiche uniquement si :
   • un ID de tracking est configuré dans FN_TRACKING_CONFIG, et
   • aucun choix n'a encore été enregistré.
   Refuser est aussi simple qu'accepter (exigence CNIL).
   Charge APRÈS js/tracking.js.
   ============================================================ */
(() => {
  'use strict';
  const T = window.FN_TRACK, CFG = window.FN_TRACKING_CONFIG || {};
  if (!T) return;
  const anyId = ['ga4', 'metaPixel', 'tiktokPixel', 'gtm', 'googleAds'].some(k => CFG[k]);

  /* LE LIEN « COOKIES » EST POSE AVANT TOUTE SORTIE ANTICIPEE.
     Il figure dans le pied de page des dix pages : s'il est visible, il doit
     repondre. Et quand aucun traceur n'est configure, il n'y a rien a retirer —
     on retire alors le lien plutot que d'afficher une commande sans effet. */
  document.addEventListener('click', (e) => {
    const lien = e.target.closest('[data-consent-reopen]');
    if (!lien) return;
    e.preventDefault();
    try { localStorage.removeItem('fn_consent_v1'); } catch (_) {}
    if (T && T.consent) T.consent(false);     // on repart d'un refus, jamais d'un oui implicite
    location.reload();
  });

  if (!anyId) {
    document.querySelectorAll('[data-consent-reopen]').forEach(a => { a.hidden = true; });
    return;                                   // aucun traceur → aucune banniere, aucun lien
  }
  /* Le choix est lu par la fonction horodatee de tracking.js : les deux
     fichiers doivent partager le MEME format, sinon le bandeau se represente a
     chaque page. Au-dela de six mois, un choix expire redevient un non-choix. */
  const lire = window.FN_CONSENT_READ || (() => {
    try { const b = localStorage.getItem('fn_consent_v1');
          return (b === 'granted' || b === 'denied') ? b : null; } catch (_) { return null; }
  });
  const deja = lire();

  /* LE RETRAIT DOIT ETRE AUSSI SIMPLE QUE L'ACCEPTATION (RGPD art. 7 §3).
     Le bandeau affirme « vous pouvez changer d'avis a tout moment » : jusqu'ici
     aucun mecanisme ne le permettait, et les mentions legales conseillaient de
     vider son navigateur — ce qui n'est pas un retrait aise.
     Ce lien est pose AVANT le `return` ci-dessous : il doit repondre meme quand
     le bandeau est deja masque, c'est-a-dire tout le temps. */
  if (deja === 'granted' || deja === 'denied') return;

  const css = `
  .fn-consent{position:fixed;left:16px;right:16px;bottom:16px;z-index:9999;background:#111;color:#fff;
    border-radius:16px;padding:16px 18px;display:flex;flex-wrap:wrap;gap:12px;align-items:center;
    box-shadow:0 12px 40px rgba(0,0,0,.28);font-size:.9rem;line-height:1.45;max-width:680px;margin:0 auto}
  .fn-consent p{margin:0;flex:1 1 260px}
  .fn-consent b{color:#fff}
  .fn-consent__acts{display:flex;gap:8px}
  .fn-consent button{font:inherit;font-weight:600;border-radius:999px;padding:10px 18px;cursor:pointer;border:0}
  .fn-consent__ok{background:#fff;color:#111}
  .fn-consent__no{background:transparent;color:#fff;border:1px solid rgba(255,255,255,.4)!important}
  @media (max-width:520px){.fn-consent{flex-direction:column;align-items:stretch;text-align:center}
    .fn-consent__acts{justify-content:center}}`;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  const bar = document.createElement('div');
  bar.className = 'fn-consent';
  bar.setAttribute('role', 'dialog');
  bar.setAttribute('aria-label', 'Cookies et mesure d’audience');
  bar.innerHTML = `
    <p><b>Cookies &amp; mesure d’audience.</b> Avec votre accord, nous déposons des cookies de mesure
    d’audience et de performance publicitaire (Google&nbsp;Analytics, Meta, TikTok) pour améliorer la
    boutique. Aucun dépôt, aucun envoi avant votre choix. Vous pouvez changer d’avis à tout moment.
    <a href="/pages/mentions-legales#donnees">Données personnelles et cookies</a>.</p>
    <div class="fn-consent__acts">
      <button class="fn-consent__no" type="button">Continuer sans accepter</button>
      <button class="fn-consent__ok" type="button">Accepter</button>
    </div>`;
  const close = () => bar.remove();
  bar.querySelector('.fn-consent__ok').addEventListener('click', () => { T.consent(true); close(); });
  bar.querySelector('.fn-consent__no').addEventListener('click', () => { T.consent(false); close(); });
  document.body.appendChild(bar);
})();
